import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouteStandingOrderService } from '../service/route-standing-orders.service';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'app-route-standing-orders',
  templateUrl: './route-standing-orders.component.html',
  styleUrls: ['./route-standing-orders.component.css']
})
export class RouteStandingOrdersComponent implements OnInit, OnDestroy {

  search: string = '';
  routeStandingOrders = [];
  status = "active";
  selectedDropdownIndex: number = -1;
  toggleActionButtons: boolean = false;

  constructor(
    private routeStandingOrderService: RouteStandingOrderService,
  ) { }

  ngOnInit() {
    this.getRouteStandingOrders();
  }

  onChangeStatus(evt) {
    this.getRouteStandingOrders();
  }

  getRouteStandingOrders() {
    const queryParams = {
      status: this.status
    }

    this.routeStandingOrderService
      .getRouteStandingOrders(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          this.routeStandingOrders = data;
        } else {
          this.routeStandingOrders = [];
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  showActionButtons(index) {
    if (this.selectedDropdownIndex === index) {
      this.toggleActionButtons = !this.toggleActionButtons;
    } else {
      this.selectedDropdownIndex = index;
      this.toggleActionButtons = true;
    }
  }

  closeActionMenu(event) {
    this.toggleActionButtons = false;
    this.selectedDropdownIndex = -1;
  }

  ngOnDestroy(): void {
  }
}
